import styled from 'styled-components';

export const DemandaContainer = styled.div`
  margin-top: 32px;
  position: relative;
`;

export const DemandaHeader = styled.div`
  gap: 10px;

  display: flex;
  align-items: center;

  p {
    margin: 0;
  }
`;

export const TableContainer = styled.div`
  padding-top: 32px;
  //padding: 24px 16px;

  overflow: visible;
  //-shadow: 0px 2px 2px 2px rgba(0, 0, 0, 0.02), 0px 2px 12px rgba(0, 0, 0, 0.08);

  //border-radius: 4px;
`;

export const LoteStatus = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
  }
`;
